export default __webpack_public_path__ + "static/media/ecom.2fb18f1e.png";